import React, { useState, useEffect } from "react";

import Container from 'react-bootstrap/Container';
import Row       from 'react-bootstrap/Row';
import Col       from 'react-bootstrap/Col';

import api, {apiCep} from "../../../src/services/apis";

import Header        from "./Header";
import Thanks        from "./Thanks";

import { zzCheckNull } from "../../../src/services/megazzone";

import { zzLog }     from "../../../src/services/megazzone";

import Etapa1        from "../Campanha/Etapa1";
import Etapa2        from "../Campanha/Etapa2";
import Etapa3        from "../Campanha/Etapa3";

import "../../portal.css";

const Form = () => {

  const [ etapa    , setEtapa ]     = useState( 1 );

  const [ tblProdutos, setTblProdutos ] = useState([]);

  const [ canSubmit, setCanSubmit ] = useState( false );
  const [ btnSubmit, setBtnSubmit ] = useState( false );

  const [ thanks, setThanks ]       = useState(false);

	const [frm, setFrm] = useState({
    cnpj         : '',
    contato      : '',
    fone         : '',
    email        : '',
    empresa      : '',
    ramo         : '',
    cep          : '',
    bairro       : '',
    endereco     : '',
    cidade       : '',
    estado       : '',
    func         : '',
    produto_id   : '',
    doses        : '',
    aplicacao    : '',
    obs          : '',
    origem       : '',
    selectedFile : ''
	});

  /* ------------------------------------------------------------------------ *
   *                                                            LOAD PRODUTOS *
   * ------------------------------------------------------------------------ */
  const tokenjwt = "339|9eIgAUyeTwQcbwalVm1XJlqMJnrAEQSn2Zlynxhx";
  const config   = {
    headers: { Authorization: `Bearer ${tokenjwt}` }
  };

  const loadProdutos = () => {
    api.get( '/produtos', config )
    .catch(function(error) {
        console.error( "** PRODUTOS ERROR ** ", error.response.data );
    })
    .then( (response) => {
        var arrayTbl = [];   
        if ( response.data && response.data.length ) {       
            arrayTbl = response.data.map((row) => {
                return {
                    id   : row.id    ,
                    nome : row.nome
                };
            });        
            setTblProdutos( arrayTbl );
            setFrm( { ...frm, produto_id : arrayTbl[0].id } );
        }
    })
  }

  /* ------------------------------------------------------------------------ *
   *                                                       HANDLE CHANGE FORM *
   * ------------------------------------------------------------------------ */
	const handleChange = e => {
    const { name, value } = e.target;

    let gambiarra      = 0;
    let validadeErrors = {};

    if (name==='selectedFile') {
      setFrm({ ...frm, [name]: e.target.files[0] });
    }
    else {
      setFrm({ ...frm, [name]: value });
    }

    //-------------------------------------------------- individuais
    if ( name==='cep' ) {
      if ( value.trim()==='' ) {
        validadeErrors.cep = "CEP é obrigatório";
        gambiarra++;
      }
      else {
        var limite = (value.includes("-") ? 9 : 8); 
        if ( value.length <= limite ) {
          if ( value.length === limite ) {
            apiCep.get( value + "/json/" )
            .catch(function(error) {
              console.error( "** CEP ERROR ** ", error.response.data );
            })
            .then(( response ) => {
              if ( ! response.data.erro ) {
                setFrm( { ...frm, 
                          cep      : response.data.cep        ,
                          endereco : response.data.logradouro ,
                          bairro   : response.data.bairro     ,
                          cidade   : response.data.localidade ,
                          estado   : response.data.uf
                } );
              }
            })
          }
        }
      }
    }

    if ( frm.contato.trim()==='' ) {
      validadeErrors.contato = "Contato é obrigatório";
      gambiarra++;
    }
    if ( frm.fone.trim()==='' ) {
      validadeErrors.fone = "Fone é obrigatório";
      gambiarra++;
    }
    if ( frm.email.trim()==='' ) {
      validadeErrors.email = "Email é obrigatório";
      gambiarra++;
    }
    /*
    if ( values.email.trim()!=='' && !(/^[a-z0-9.]+@[a-z0-9]+\.[a-z]+\.([a-z]+)?$/i.test(values.email.trim())) ) {
      validadeErrors.email = "Formato do email esta errado";
      gambiarra++;
    }
    */
    if ( frm.cnpj.trim()==='' ) {
      validadeErrors.cnpj = "CNPJ é obrigatório";
      gambiarra++;
    }
    if ( frm.empresa.trim()==='' ) {
      validadeErrors.empresa = "Empresa é obrigatório";
      gambiarra++;
    }  
    if ( frm.doses.trim()==='' ) {
      validadeErrors.doses = "Doses é obrigatório";
      gambiarra++;
    }

    setCanSubmit( gambiarra === 0 )
	}

  /* ------------------------------------------------------------------------ *
   *                                                            HANDLE SUBMIT *
   * ------------------------------------------------------------------------ */
	const handleSubmit = e => {
		e.preventDefault();
  
    if ( canSubmit && btnSubmit ) {
      let formData = new FormData();
      formData.append( "selectedFile", frm.selectedFile );    // funciona

      formData.append( "status",     'N' );
      formData.append( "contato",    zzCheckNull( frm.contato ));
      formData.append( "fone",       zzCheckNull( frm.fone ));
      formData.append( "email",      zzCheckNull( frm.email ));
      formData.append( "empresa",    zzCheckNull( frm.empresa ));
      formData.append( "ramo",       zzCheckNull( frm.ramo ));
      formData.append( "cep",        zzCheckNull( frm.cep ));
      formData.append( "bairro",     zzCheckNull( frm.bairro ));
      formData.append( "endereco",   zzCheckNull( frm.endereco ));
      formData.append( "cidade",     zzCheckNull( frm.cidade ));
      formData.append( "uf",         zzCheckNull( frm.estado ));
      formData.append( "func",       zzCheckNull( frm.func ));
      formData.append( "produto_id", zzCheckNull( frm.produto_id ));
      formData.append( "doses",      zzCheckNull( frm.doses ));
      formData.append( "aplicacao",  zzCheckNull( frm.aplicacao ));
      formData.append( "obs",        zzCheckNull( frm.obs ));
      formData.append( "origem",     zzCheckNull( frm.origem ));
          
      const tokenjwt = "339|9eIgAUyeTwQcbwalVm1XJlqMJnrAEQSn2Zlynxhx";
      const config   = {
        headers: { Authorization: `Bearer ${tokenjwt}`,
                  'Content-Type': 'multipart/form-data'
                }
      };
    
      api.post( "/pluginforms", formData, config )
      .then(( response ) => {
        setThanks( true );
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) { // no response
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      });

    }
	}

  /* ------------------------------------------------------------------------ *
   *                                                               USE EFFECT *
   * ------------------------------------------------------------------------ */
  useEffect(() => {
    zzLog( '[form-page-access] Monte sua Campanha', 10 );
    loadProdutos();
  }, [] );

  return (
    <Container>

      <Header />

      { (thanks)
      ?
        <Thanks frm={frm} />
      : 
        <form onSubmit  = {handleSubmit} 
          className = "form-floating" 
          accept    = ".xls, .xlsx"
          encType   = "multipart/form-data">

          <Row style={{margin: "60px 0px 40px", }}>
            <Col className="text-center"><h3 className="titulos">MONTE SUA CAMPANHA</h3></Col>
          </Row>

          <Row style={{margin: "40px 0px 30px" }}>
            <Col md={{ span: 2, offset: 3}} className="text-center">
              <button onClick={()=>setEtapa(1)} className={(etapa===1) ? "btn btn-primary btn-portal-azul" : "btn btn-light"}>
                <span className="big-numbers">1</span><br/>Dados do Contato
              </button>
            </Col>

            <Col md={{ span: 2}} className="text-center">
              <button onClick={()=>setEtapa(2)} className={(etapa===2) ? "btn btn-primary btn-portal-azul" : "btn btn-light"}>
                <span className="big-numbers">2</span><br/>Dados da Empresa
              </button>
            </Col>

            <Col md={{ span: 2}} className="text-center">
              <button onClick={()=>setEtapa(3)} className={(etapa===3) ? "btn btn-primary btn-portal-azul" : "btn btn-light"}>
                <span className="big-numbers">3</span><br/>Sobre a Campanha
              </button>
            </Col>
          </Row>

          { (etapa===1) && <Etapa1 values={frm} handleChange={handleChange} /> }

          { (etapa===2) && <Etapa2 values={frm} handleChange={handleChange} /> }

          { (etapa===3) && <Etapa3 values={frm} handleChange={handleChange} tblProdutos={tblProdutos}/> }

          <Row style={{margin: "30px 0px", }}>
            <Col className="text-center">
              { (etapa>1) && 
                <><button onClick={ () => setEtapa(etapa-1) } className="btn btn-primary btn-portal-azul btn-lg">Anterior</button>{"  "}</> 
              }

              <button onClick={ () => setBtnSubmit(true) } className="btn btn-success btn-portal-verde btn-lg" disabled={!canSubmit}>
                Enviar sua Solicitação
              </button>

              { (etapa<3) && 
                <>{"  "}<button onClick={ () => setEtapa(etapa+1) } className="btn btn-primary btn-portal-azul btn-lg">Próxima</button></> 
              }

            </Col>
          </Row>

        </form>
      }        
    </Container>    
  );
}
export default Form;